// Map current V1 host to its V2 counterpart for cross-deployment redirects.
//
// V1 → V2 host mapping:
//   fundschaindev.worldbank.org   → fundschainevolutionpilotdev.worldbank.org
//   fundschainqa.worldbank.org    → fundschainevolutionpilotqa.worldbank.org
//   fundschain.worldbank.org      → fundschainevolutionpilot.worldbank.org

const V1_TO_V2_HOST: Record<string, string> = {
	'fundschaindev.worldbank.org': 'fundschainevolutionpilotdev.worldbank.org',
	'fundschainqa.worldbank.org': 'fundschainevolutionpilotqa.worldbank.org',
	'fundschain.worldbank.org': 'fundschainevolutionpilot.worldbank.org',
};

/**
 * Returns the V2 host for the current V1 host, or null if the current host
 * has no known V2 counterpart (e.g. localhost, an already-V2 host, or an
 * unrecognized environment).
 */
export const getV2HostForCurrent = (): null | string => {
	if (typeof window === 'undefined') {
		return null;
	}

	return V1_TO_V2_HOST[window.location.hostname] ?? null;
};

/**
 * Build the absolute V2 URL for a project by idWbg, or null if the current
 * host is not a recognized V1 deployment.
 */
export const buildV2ProjectUrl = (idWbg: string): null | string => {
	const host = getV2HostForCurrent();

	if (!host) {
		return null;
	}

	return `https://${host}/project/${idWbg}`;
};
